<template>
    <div class="ui-select-unity">
        <ui-overlay-load v-if="load" />

        <div v-if="!optionsComputed.length" class="ui-no-content">
            <div class="title">Nenhum item foi encontrado.</div>
        </div>

        <template v-else>
            <div class="items-wrapper">
                <div class="items-scroller">
                    <div class="items">
                        <div
                            v-for="option of optionsComputed"
                            :key="option.id"
                            class="item"
                            :class="{
                                'current': option == selected,
                                'disabled-item': option.permission_action == 0 || option.permission_action == false
                            }"
                            @click="select(option)"
                        >

                            <ui-product-card
                                :unity="option"
                                :product="product"
                                :border="option !== selected"
                                :color="colorBySituation(option.situation)"
                                small
                            />

                            <i v-if="!(option.permission_action == 0 || option.permission_action == false)" class="fal fa-check"/>
                        </div>
                    </div>
                </div>
            </div>

            <div class="info">
                <div class="title">Resumo das unidades: </div>
                <div class="units">
                    <span class="circle available"/> <span>{{ situationComputed.available }}</span> <span>disponível</span>
                </div>

                <div v-if="showReserved" class="units">
                    <span class="circle pre-reserved"/> <span>{{ situationComputed.pre_reserved }}</span> <span>pré-reserva</span>
                </div>

                <div v-if="showReserved" class="units">
                    <span class="circle reserved"/> <span>{{ situationComputed.reserved }}</span> <span>reservado</span>
                </div>
            </div>
        </template>

    </div>
</template>

<script>
    import { uiOverlayLoad } from '@/components/ui'
    import uiProductCard from "../product-card"

    export default {
        name: 'ui-sales-select-unit',

        components: {
            uiProductCard,
            uiOverlayLoad,
        },

        props: {
            value: {
                type: Array,
                required: true,
                default () {
                    return []
                }
            },

            product: {
                type: Object,
                required: true,
                default () {
                    return {}
                }
            },

            default: {
                type: Number,
                required: false,
                default: null,
            },

            load: {
                type: Boolean,
                required: false,
            },

            showReserved: {
                type: Boolean,
                required: false,
                default: false,
            }
        },

        data() {
            return {
                selected: null
            }
        },

        computed: {
            optionsComputed() {
                return this.value
            },

            situationComputed() {
                let data = {
                    reserved: 0,
                    pre_reserved: 0,
                    available: 0
                }

                this.optionsComputed.forEach(element => {
                    switch (element.situation) {
                        case 'reserved':
                            data.reserved++
                            break

                        case 'pre-reserve':
                            data.pre_reserved++
                            break

                        default:
                            data.available++
                            break
                    }
                })
                return data
            },

            selectedComputed: {
                get() {
                    return this.default ? this.optionsComputed[this.default] : this.selected
                },
                set(value) {
                    if(value) {
                        this.selected = value
                        this.$emit('input', value.id)
                    }
                }
            },
        },

        watch: {
            value: function (newValue, oldValue) {
                if(newValue !== oldValue) {
                    this.selected = null
                    this.selectedComputed = null
                }
            }
        },

        created: async function () {
            await this.$nextTick().then(() => {
                if (this.default) {
                    this.selected = this.optionsComputed.find(option => option.id === this.default)
                    this.$emit("input", this.selected?.id)
                }
            })
        },

        methods: {
            select(option) {
                if (this.selectedComputed !== option) {
                    this.selectedComputed = option
                }
            },

            /**
             * Retorna uma cor de acordo com o status/situação de uma unidade
             */
            colorBySituation(situation) {
                let color = ''

                switch (situation) {
                    case 'reserved':
                        color = '#FF9B0F'
                        break

                    case 'pre-reserve':
                        color = '#FFD755'
                        break

                    default:
                        color = '#5AC387'
                        break
                }

                return color
            },
        },
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>